import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { Layout } from '@/components/layout';
import IconCard from '@/assets/icons/heroIcons/Card-front.svg';
import IconThird from '@/assets/icons/heroIcons/Icon-third.svg';
import MoreInfoSection from '@/sections/MoreInfo';
import { SectionDelimiter } from '@/components/SectionDelimiter';
import { getIntlProps, type IntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import { useTranslation } from 'react-i18next';
import { LINKS } from '@/constants/links';
import React from 'react';
import IconDeferredPayment from '@/assets/icons/heroIcons/Deferred-payment.svg';
import HeroSimple from '@/sections/HeroSimple';
import { SeoHeader } from '@/components/SeoHeader';
import { useIsSelectedLanguage } from '@/hooks/useIsSelectedLanguage';
import IconShoppingCart from '@/assets/icons/heroIcons/Shopping-cart.svg';
import IconMobile from '@/assets/icons/heroIcons/Device-mobile.svg';
import IconUser from '@/assets/icons/heroIcons/User-group.svg';
import { InformationMemorandum } from '@/sections/personalData/InformationMemorandum';
import { PersonalInformationManagement } from '@/sections/personalData/PersonalInformationManagement';
import { Partners } from '@/sections/personalData/Partners';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
import IconMaxi from '@/assets/icons/heroIcons/Maxi.svg';
import { CareerMemorandum } from '@/sections/personalData/CareerMemorandum';
interface Props extends IntlProps {
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(t0) {
  const $ = _c(34);
  const {
    menuPromoBanners
  } = t0;
  usePageView("informationMemorandum");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["personalData", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const isCsLanguage = useIsSelectedLanguage("cs");
  const isHuLanguage = useIsSelectedLanguage("hu");
  let t2;
  if ($[1] !== t) {
    t2 = t("seo.title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("seo.description");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <SeoHeader title={t2} description={t3} />;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("banner.title");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <HeroSimple title={t5} />;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  let t8;
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <InformationMemorandum />;
    t8 = <PersonalInformationManagement />;
    t9 = <Partners />;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t7 = $[12];
    t8 = $[13];
    t9 = $[14];
  }
  let t10;
  if ($[15] !== isHuLanguage) {
    t10 = !isHuLanguage && <CareerMemorandum />;
    $[15] = isHuLanguage;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10) {
    t11 = <div className="relative z-10 mx-auto flex max-w-[75rem] flex-col gap-6 px-4 pb-20 lg:pb-40">{t7}{t8}{t9}{t10}</div>;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t6) {
    t12 = <div className="bg-blue-50">{t6}{t11}</div>;
    $[19] = t11;
    $[20] = t6;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <SectionDelimiter color="bg-blue-100" background="bg-blue-50" />;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== isCsLanguage || $[24] !== t) {
    t14 = <div className="relative z-10"><MoreInfoSection buttons={isCsLanguage ? [{
        analyticsParam: "whistleblowingMoreInfoDeferredPayment",
        icon: <IconDeferredPayment className="fillButtonIcon" />,
        testId: "whistleblowingMoreInfoDeferredPayment",
        title: t("core:products.deferredPayment"),
        to: LINKS().deferredPayment
      }, {
        analyticsParam: "whistleblowingMoreInfoRevolvingApplication",
        icon: <IconMaxi className="fillButtonIcon" />,
        testId: "whistleblowingMoreInfoRevolvingApplication",
        title: t("core:products.revolving"),
        to: LINKS().revolving
      }, {
        analyticsParam: "whistleblowingMoreInfoPayInThree",
        icon: <IconThird className="fillButtonIcon" />,
        testId: "whistleblowingMoreInfoPayInThree",
        title: t("core:link.payInThree"),
        to: LINKS().payInThree
      }, {
        analyticsParam: "whistleblowingMoreInfoCard",
        icon: <IconCard className="fillButtonIcon" />,
        testId: "whistleblowingMoreInfoCard",
        title: t("core:products.card"),
        to: LINKS().card
      }] : [{
        analyticsParam: "whistleblowingMoreInfoPayInThree",
        icon: <IconThird className="fillButtonIcon" />,
        testId: "whistleblowingMoreInfoPayInThree",
        title: t("core:products.payInThree"),
        to: LINKS().payInThree
      }, {
        analyticsParam: "whistleblowingMoreInfoWhereToShop",
        icon: <IconShoppingCart className="fillButtonIcon" />,
        testId: "whistleblowingMoreInfoWhereToShop",
        title: t("core:products.whereToShop"),
        to: LINKS().whereToShop
      }, {
        analyticsParam: "whistleblowingMobileApp",
        icon: <IconMobile className="fillButtonIcon" />,
        testId: "whistleblowingMoreInfoMobileApp",
        title: t("core:products.mobileApp"),
        to: LINKS().mobileApp
      }, {
        analyticsParam: "whistleblowingMoreInfoAboutCompany",
        icon: <IconUser className="fillButtonIcon" />,
        testId: "whistleblowingMoreInfoAboutCompany",
        title: t("core:link.aboutUs"),
        to: LINKS().aboutCompany
      }]} /></div>;
    $[23] = isCsLanguage;
    $[24] = t;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="bgCircle absolute right-0 bottom-0 translate-x-1/4 translate-y-1/4 rotate-180" />;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t14) {
    t16 = <div className="relative overflow-hidden bg-blue-100">{t14}{t15}</div>;
    $[27] = t14;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== menuPromoBanners || $[30] !== t12 || $[31] !== t16 || $[32] !== t4) {
    t17 = <Layout menuPromoBanners={menuPromoBanners}>{t4}{t12}{t13}{t16}</Layout>;
    $[29] = menuPromoBanners;
    $[30] = t12;
    $[31] = t16;
    $[32] = t4;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  return t17;
}
export const getStaticProps: GetStaticProps = async ctx => ({
  props: {
    menuPromoBanners: await getAllPageMenuPromoBanners(),
    ...(await getIntlProps(ctx, ['core', 'personalData', 'partners']))
  }
});